import React from "react";
import Header from "../Components/Header";
import HeroSection from "./Hero";
import Understanding from "./Understanding";
 import Platform from "./Unlock";
import DigitalAssets from "./FastandFlexible";
 import Commitment from "./Patent";
import Footer from "../Components/Footer";
import DeploymentSection from "./innovative";
import CTASection from "../AboutUs/CtaSection";
import Features from "./Features";

function TennetCustody() {
  return (
    <div>
      <main>
        <Header />
        <HeroSection />
        <DeploymentSection />
        <Commitment />
        <Platform />
        <Features />
        <DigitalAssets />
        <Understanding />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default TennetCustody;
